import React, {useState, useEffect} from 'react';
import '../Styles/NoInternet.css'
<link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css" rel="stylesheet"></link>

const NoInternet = (props) => {
   
    const [isOnline, setOnline] = useState(true);

   
    useEffect(()=>{
        setOnline(navigator.onLine)
    },[])

   
    window.addEventListener('online', () => {
        setOnline(true)
    });

    window.addEventListener('offline', () => {
        setOnline(false)
    });

  
    if(isOnline){
    return(
        props.children
    )
    } else {
        return(
        <>
        <div class="page-404">
    <div class="outer">
        <div class="middle">
            <div class="inner">
               
                <div class="inner-circle"><i class="fa fa-cogs"></i><span>500</span></div>
                <span class="inner-status">Opps! Internal Server Error!</span>
                <span class="inner-detail">No Internet Connection!</span>
                
            </div>
        </div>
    </div>
</div>
        </>
        )
    }
}

export default NoInternet;